<main>
  <div class="content signing">
    <app-signing-session-bar />

    <nav class="signing__breadcrumb">
      <i class="pi pi-home"></i>
      <i class="pi pi-angle-right signing__breadcrumb-sep"></i>
      <span>{{ 'Signing_Menu_Signature' | translateWF: 'Signature' }}</span>
      <i class="pi pi-angle-right signing__breadcrumb-sep"></i>
      <span class="signing__breadcrumb-current">{{ 'Signing_Dashboard_Breadcrumb' | translateWF: 'My Documents' }}</span>
    </nav>

    <div class="signing__header">
      <div>
        <h1 class="signing__title">{{ 'Signing_Dashboard_Title' | translateWF: 'Signing Dashboard' }}</h1>
        <p class="signing__subtitle">
          {{ 'Signing_Dashboard_Subtitle' | translateWF: 'Documents routed to you for signature, regardless of source module. Start a session to sign anything waiting on you.' }}
        </p>
      </div>
      <div class="signing__actions">
        @if (state.isPendingVerification()) {
          <p-button
            variant="text"
            severity="danger"
            icon="pi pi-trash"
            label="{{ 'Signing_Dashboard_Discard' | translateWF: 'Discard' }}"
            [pTooltip]="'Signing_Dashboard_Discard_Tooltip' | translateWF: 'Close the session you opened without verifying it'"
            tooltipPosition="bottom"
            (onClick)="otpDialog.requestCloseSession()"
          />
        }
        <p-button
          [icon]="sessionButton().icon"
          [label]="sessionButton().key | translateWF: sessionButton().fallback"
          [disabled]="buttonDisabled()"
          [pTooltip]="state.isActive() ? ('Signing_Dashboard_SessionActive_Tooltip' | translateWF: 'End your active session to start another') : ''"
          tooltipPosition="left"
          (onClick)="onPrimaryAction()"
        />
      </div>
    </div>

    @if (needsSetup()) {
      <div class="signing__notice">
        <i class="pi pi-mobile signing__notice-icon"></i>
        <div class="signing__notice-body">
          <span class="signing__notice-title">{{ 'Signing_Dashboard_Setup_Title' | translateWF: 'Set up your authenticator to start signing' }}</span>
          <span class="signing__notice-text">
            {{
              'Signing_Dashboard_Setup_Text'
                | translateWF: 'Signing sessions are verified with a code from Microsoft Authenticator on your phone. It takes about a minute, and only once.'
            }}
          </span>
        </div>
        <p-button variant="outlined" label="{{ 'Signing_Dashboard_SetupAuthenticator' | translateWF: 'Set Up Authenticator' }}" (onClick)="setupDialog.open()" />
      </div>
    }

    <div class="signing__filter">
      <label class="signing__filter-label">{{ 'Signing_Dashboard_Initiator' | translateWF: 'Initiator' }}</label>
      <div class="signing__chip" [pTooltip]="'Signing_Dashboard_Initiator_Tooltip' | translateWF: 'Only Purchase Orders currently route documents here'">
        <i class="pi pi-shopping-cart"></i>
        {{ 'Signing_Dashboard_PurchaseOrders' | translateWF: 'Purchase Orders' }}
        <i class="pi pi-lock signing__chip-lock"></i>
      </div>
    </div>

    <p-table [value]="[]">
      <ng-template #header>
        <tr>
          <th>{{ 'Signing_Dashboard_Col_Document' | translateWF: 'Document' }}</th>
          <th>{{ 'Signing_Dashboard_Col_Initiator' | translateWF: 'Initiator' }}</th>
          <th>{{ 'Signing_Dashboard_Col_Related' | translateWF: 'Related Record' }}</th>
          <th>{{ 'Signing_Dashboard_Col_Signers' | translateWF: 'Signers' }}</th>
          <th>{{ 'Signing_Dashboard_Col_Status' | translateWF: 'Status' }}</th>
          <th>{{ 'Signing_Dashboard_Col_Received' | translateWF: 'Received' }}</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template #empty>
        <tr>
          <td colspan="7">
            <div class="signing__empty">
              <i class="pi pi-inbox signing__empty-icon"></i>
              <span class="signing__empty-title">{{ 'Signing_Dashboard_Empty' | translateWF: 'No documents are waiting for your signature.' }}</span>
              <span class="signing__empty-hint">
                {{ 'Signing_Dashboard_Empty_Hint' | translateWF: 'Purchase Orders routed to you will appear here.' }}
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</main>

<app-signing-otp-dialog />
<app-signing-authenticator-setup (startSession)="startSession()" />
